module.exports = __webpack_public_path__ + "img/thumbnail_WesternChimpanzee_m_albino.dc6e846d.png";